import moment from 'moment';
import range from 'lodash/range';


export function groupByWeek({ days, startTime, endTime }) {
  const start = moment(startTime).startOf('isoWeek');
  const end = moment(endTime).endOf('isoWeek');

  const weeks = [];
  for (let i = 0; i < days.length; i++) {
    const day = moment(days[i].date);
    const weekOfYear = day.week();

    let lastWeek = weeks[weeks.length - 1];
    if (!lastWeek || lastWeek.weekOfYear !== weekOfYear) {
      lastWeek = {
        start: moment(day).startOf('week').format(ttb.constants.dateTime.SHORT_DATE_FORMAT),
        end: moment(day).endOf('week').format(ttb.constants.dateTime.SHORT_DATE_FORMAT),
        weekOfYear,
        days: [],
        index: weeks.length,
      };
      weeks.push(lastWeek);
    }
    lastWeek.days[day.weekday()] = {
      dayDate: day.format(ttb.constants.dateTime.SHORT_DATE_FORMAT),
      value: days[i],
    };
  }
  if (weeks.length) {
    weeks[0].start = start.format(ttb.constants.dateTime.SHORT_DATE_FORMAT);
    weeks[weeks.length - 1].end = end.format(ttb.constants.dateTime.SHORT_DATE_FORMAT);
  }
  return weeks;
}

export function getDaysOfWeek(someDayOfWeek = moment()) {
  const startOfWeek = someDayOfWeek.startOf('isoWeek');
  return range(0, 7).map(day => ({
    day,
    absDay: startOfWeek.weekday(day).day(),
    weekday: startOfWeek.weekday(day).format('ddd'),
    weekDayFormat: startOfWeek.weekday(day).format('dd'),
    monthDayFormat: startOfWeek.weekday(day).format(ttb.constants.dateTime.SHORT_DATE_FORMAT),
  }));
}

export function getWeeks({ startTime, endTime }) {
  const start = moment(startTime).startOf('isoWeek');
  const end = moment(endTime).endOf('isoWeek');
  const weeks = [{ start: moment(start) }];
  const duration = moment.duration(end.toDate().getTime() - start.toDate().getTime());
  const weekCount = Math.round(duration.asWeeks()) - 1;
  const startOfWeek = start.clone();
  for (let i = 0; i < weekCount; i++) {
    weeks[i].end = moment(startOfWeek).endOf('week');
    startOfWeek.add(1, 'w');
    weeks.push({
      start: moment(startOfWeek),
    });
  }
  weeks[weeks.length - 1].end = end;
  return weeks.map(week => ({
    ...week,
    startFormat: week.start.format(ttb.constants.dateTime.SHORT_DATE_FORMAT),
    endFormat: week.end.format(ttb.constants.dateTime.SHORT_DATE_FORMAT),
  }));
}



// WEBPACK FOOTER //
// ../utils/datetime.js